import React, { useMemo, useEffect } from "react";

import "./style.scss";
import { Controller, useFormContext } from "react-hook-form";
import { Link, useParams } from "react-router-dom";
import { FormControl } from "@chakra-ui/react";
import Select from "~components/Form/components/Select";
import { initialPath } from "~misc/paths";
import { CleanFiltersIcon, IconSearch } from "~misc/icons";
import { getGrupoProdutosOptions, getProdutoOptions } from "../../PriceSearchV2/utils/getOptionsFromSearchs";
import prepareForOptions from "~services/utils/prepareForOptions";
import PropTypes from "prop-types";

const PriceSearchFilter = ({
  graphsFilter,
  totalItems,
  lastSearchDate,
  filteredItemsCount,
  loading,
  origem,
  cameFromVisitaView,
}) => {
  const { watch, control, reset, setValue } = useFormContext();
  const selectedGrupo = watch("grupoProduto");
  const produtoValue = watch("produto");
  const { parameter } = useParams();

  const isDisabled = !graphsFilter || graphsFilter?.length === 0;

  const optionsPeriodo = [
    { label: "Todos", value: "" },
    { label: "Último 30 dias", value: "trintaDias" },
    { label: "Últimos 15 dias", value: "quinzeDias" },
    { label: "Últimos 7 dias", value: "seteDias" },
    { label: "Hoje", value: "hoje" },
  ];

  const { gruposArray, produtosArray } = useMemo(() => {
    if (!graphsFilter?.length) return { gruposArray: [], produtosArray: [] };
    const objGrupo = getGrupoProdutosOptions(graphsFilter);
    const objProduto = getProdutoOptions(graphsFilter);
    return { gruposArray: Object.values(objGrupo || {}), produtosArray: Object.values(objProduto || {}) };
  }, [graphsFilter]);

  const grupoProdutosOptions = useMemo(() => prepareForOptions(gruposArray, "nome", "id"), [gruposArray]);

  const produtosOptions = useMemo(() => {
    const base = produtosArray || [];
    const filtered = selectedGrupo ? base.filter((p) => String(p.grupoProdutoId) === String(selectedGrupo)) : base;
    return prepareForOptions(filtered, ["descricaoProduto"], "id");
  }, [produtosArray, selectedGrupo]);

  useEffect(() => {
    if (!selectedGrupo) return;
    if (!produtoValue) return;
    const belongs = (produtosArray || []).some(
      (p) => String(p.id) === String(produtoValue) && String(p.grupoProdutoId) === String(selectedGrupo)
    );
    if (!belongs) setValue("produto", "");
  }, [selectedGrupo, produtoValue, produtosArray, setValue]);

  const optionsOrder = [
    { label: "Mais Recentes", value: "recentes" },
    { label: "Antigos", value: "asc" },
  ];

  return (
    <>
      <div className="flex flex-col md:flex-row items-center md:gap-2 mt-4 pt-4 priceSeachFilter__content">
        <FormControl>
          <Controller
            name="grupoProduto"
            control={control}
            render={({ field }) => (
              <Select
                className="select-filter focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
                name="grupoProduto"
                label="Grupo de Produtos:"
                placeholder="Grupo de Produtos:"
                options={grupoProdutosOptions}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption?.value || "");
                }}
                value={grupoProdutosOptions?.find((o) => o.value === field.value) || ""}
                isDisabled={loading || isDisabled}
                loading={loading}
              />
            )}
          />
        </FormControl>
        <FormControl>
          <Controller
            name="periodo"
            control={control}
            render={({ field }) => (
              <Select
                placeholder="Período"
                label="Período:"
                className="select-filter focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
                onChange={(selectedOption) => {
                  field.onChange(selectedOption.value);
                }}
                options={optionsPeriodo}
                value={optionsPeriodo?.find((option) => option.value === field.value) || ""}
                isDisabled={loading || isDisabled}
              />
            )}
          />
        </FormControl>
        <FormControl>
          <Controller
            name="produto"
            control={control}
            render={({ field }) => (
              <Select
                className="select-filter focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
                name="produto"
                label="Produtos:"
                placeholder="Produtos:"
                options={produtosOptions}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption?.value || "");
                }}
                value={produtosOptions?.find((o) => o.value === field.value) || ""}
                isDisabled={loading || isDisabled}
                loading={loading}
              />
            )}
          />
        </FormControl>
        <FormControl>
          {parameter && (
            <Link
              to={(() => {
                let url = `${initialPath}/pesquisa-de-preco/${parameter}/nova-pesquisa`;
                const params = new URLSearchParams();

                if (origem) params.append("origem", origem);
                if (cameFromVisitaView) params.append("cameFromVisitaView", cameFromVisitaView);

                const queryString = params.toString();
                return queryString ? `${url}?${queryString}` : url;
              })()}
              className="col-span-1 button-search flex py-5 mt-[8px] h-[49.99px] px-10 bg-primaria rounded-lg gap-4 font-bold text-white text-lg justify-center items-center"
            >
              Nova Pesquisa
              <IconSearch fill="#FFF" width={14} height={14} size={18} />
            </Link>
          )}
        </FormControl>
      </div>
      <div className="flex justify-end mt-6 mb-8 items-center">
        {totalItems !== 0 && (
          <h1 className="font-bold">
            Exibindo {filteredItemsCount} de {totalItems}&nbsp;
          </h1>
        )}

        {lastSearchDate && (
          <h1 className="font-bold">
            {totalItems === 0 ? "" : "-"} Última Pesquisa: {lastSearchDate.split("-").reverse().join("/")}
          </h1>
        )}

        <button
          type="button"
          className="flex-shrink-0 flex items-center gap-4 ml-auto  mr-6 cursor-pointer"
          onClick={() => {
            reset();
          }}
        >
          <span className="font-semibold text-lg cursor-pointer">Limpar Filtros</span>
          <CleanFiltersIcon />
        </button>

        <div className="flex ml-1 ">
          <Controller
            name="order"
            control={control}
            render={({ field }) => {
              const selectedOption = optionsOrder.find((option) => option.value === field.value) || optionsOrder[0];
              return (
                <Select
                  className="no-margin"
                  variation="compact-inline"
                  label="Ordenar por:"
                  options={optionsOrder}
                  spacingControl={false}
                  onChange={(selectedOption) => {
                    field.onChange(selectedOption.value);
                  }}
                  value={selectedOption}
                />
              );
            }}
          />
        </div>
      </div>
    </>
  );
};

PriceSearchFilter.propTypes = {
  graphsFilter: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      dadosGerais: PropTypes.shape({
        produtoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        grupoProdutoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        produto: PropTypes.shape({
          nome: PropTypes.string,
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          descricaoProduto: PropTypes.string,
        }),
        grupoProduto: PropTypes.shape({
          nome: PropTypes.string,
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
      }),
    })
  ),
  totalItems: PropTypes.number.isRequired,
  lastSearchDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  filteredItemsCount: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  origem: PropTypes.string,
  cameFromVisitaView: PropTypes.string,
};

PriceSearchFilter.defaultProps = {
  graphsFilter: [],
  lastSearchDate: null,
};

export default PriceSearchFilter;
